var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Accordion } from '../../common';
import { BasePanel } from '../common/basePanel';
import { BaseVolumeTable } from '../common/baseTable';
import { QueueStatusType } from '../queue/types';
export var LearningCurveContent = function () {
    return _jsx(BaseVolumeTable, { name: "learnCurve", addColumns: [], min: 1, max: 100, simpleTitle: true, suffix: "%" });
};
export var LearningCurveAccordion = function () {
    var t = useTranslation('wizard', { keyPrefix: 'learnCurve' }).t;
    return (_jsx(Accordion, __assign({ title: t('title'), defaultExpanded: true }, { children: _jsx(BasePanel, __assign({ description: t('description'), statusType: QueueStatusType.LearnCurve, needSaveBeforeCopy: true }, { children: _jsx(LearningCurveContent, {}) })) })));
};
